var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"version"},[_vm._v(_vm._s(_vm.BUILD_VERSION))])
}
var staticRenderFns = []

export { render, staticRenderFns }